import React from 'react';
import { Link } from 'react-router-dom';
import VisualizerBackground from '../components/VisualizerBackground';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <VisualizerBackground />
      
      <div className="container mx-auto px-4 pt-32 pb-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-client-yellow">Privacy Policy</h1>
          
          <div className="prose prose-lg prose-invert">
            <p className="text-white mb-6">
              Last updated: April 8, 2025
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">1. Introduction</h2>
            <p className="text-white mb-6">
              Daryian Kelton ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. 
              This privacy policy will inform you about how we look after your personal data when you visit our website and 
              tell you about your privacy rights and how the law protects you.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">2. Information We Collect</h2>
            <p className="text-white mb-4">
              We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white">
              <li>Identity Data: includes first name, last name, username or similar identifier.</li>
              <li>Contact Data: includes email address, telephone number, and address.</li>
              <li>Technical Data: includes internet protocol (IP) address, browser type and version, time zone setting, browser plug-in types and versions, operating system and platform.</li>
              <li>Usage Data: includes information about how you use our website and services.</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">3. How We Use Your Data</h2>
            <p className="text-white mb-4">
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white">
              <li>To respond to your inquiries or fulfill your requests.</li>
              <li>To provide and maintain our services.</li>
              <li>To notify you about changes to our services.</li>
              <li>To improve our website and services.</li>
              <li>To administer and protect our business and website.</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">4. Cookies</h2>
            <p className="text-white mb-6">
              Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with 
              a good experience when you browse our website and also allows us to improve our site.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">5. Data Security</h2>
            <p className="text-white mb-6">
              We have implemented appropriate security measures to prevent your personal data from being accidentally lost, 
              used, or accessed in an unauthorized way, altered, or disclosed.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">6. Your Legal Rights</h2>
            <p className="text-white mb-4">
              Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white">
              <li>Request access to your personal data.</li>
              <li>Request correction of your personal data.</li>
              <li>Request erasure of your personal data.</li>
              <li>Object to processing of your personal data.</li>
              <li>Request restriction of processing your personal data.</li>
              <li>Request transfer of your personal data.</li>
              <li>Right to withdraw consent.</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">7. Changes to This Privacy Policy</h2>
            <p className="text-white mb-6">
              We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">8. Contact Us</h2>
            <p className="text-white mb-6">
              If you have any questions about this privacy policy, please contact us at privacy@daryiankelton.com.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
